import { render, staticRenderFns } from "./redpipe-frame.vue?vue&type=template&id=78dec151"
import script from "./redpipe-frame.vue?vue&type=script&lang=js"
export * from "./redpipe-frame.vue?vue&type=script&lang=js"
import style0 from "./redpipe-frame.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/redpipe/redpipe-frame.vue
// module id = qKz5
// module chunks = 0